var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container p-4" }, [
    _c(
      "div",
      {
        staticClass: "custom-sidenav shadow",
        style: _vm.active ? "display: block;" : "display: none;"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 pt-2 text-right" }, [
            _c(
              "a",
              {
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.active = false
                  }
                }
              },
              [_c("i", { staticClass: "fal fa-times fa-2x text-secondary" })]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [_c("main-menu")], 1)
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-3 sidenav-column" },
        [!_vm.$mq.phone ? _c("main-menu") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-9 col-12 content-column" },
        [_c("router-view")],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7050e704", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7050e704","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Index.vue
// module id = 1911
// module chunks = 0